import { NOTIFICATION_ACTION_TYPES } from '../../../constants/actionTypes/secureInboxActionTypes';

export const INITIAL_STATE = {
    content: [],
    pageable: {
        sort: {},
        pageNumber: 0,
        pageSize: 0,
        offset: 0,
        paged: false,
        unpaged: false
    },
    sort: {},
    empty: false,
    first: true,
    last: true,
    number: 0,
    numberOfElements: 0,
    numberUnread: 0,
    size: 0,
    totalElements: 0,
    totalPages: 0
};

export default (state = INITIAL_STATE, action = {}) => {
    switch (action.type) {
        case NOTIFICATION_ACTION_TYPES.SET_NOTIFICATIONS:
            return {
                ...state,
                ...action.notifications
            };
        case NOTIFICATION_ACTION_TYPES.SET_FILTERED_NOTIFICATIONS:
            return {
                ...state,
                ...action.notifications,
                totalElements: state.totalElements
            };
        case NOTIFICATION_ACTION_TYPES.SET_UNREAD_NOTIFICATIONS:
            return {
                ...state,
                numberUnread: action.numberUnread
            };
        case NOTIFICATION_ACTION_TYPES.UPDATE_NOTIFICATIONS_PAGINATION:
            return {
                ...state,
                ...action.payload
            };
        case NOTIFICATION_ACTION_TYPES.CLEAR_NOTIFICATIONS_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }
};